// extracted by mini-css-extract-plugin
export default {"season-descriptor":"season-descriptor--mp-OAzi5","seasonDescriptor":"season-descriptor--mp-OAzi5","fadeIn":"fadeIn--mp-CzXJD"};